<template>
  <div v-loading="loading">
    <div style="margin-bottom: 20px">
      <el-button type="primary"
                 size="small"
                 @click="_saveWageAttachEmp"
      >
        选择
      </el-button>
    </div>
    <bsp-table
		  reduceHeight="130"
      :data.sync="list"
      ref="accountTable"
      @select-change="selectChange"
      @select-all="selectAll"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getListpage"
      :showPagination="listQuery.page"
      show-footer
      fixed="left"
    >
      <vxe-table-column
        type="selection"
        width="60"
        fixed="left"
      />
      <vxe-table-column
        fixed="left"
        type="index"
        title="序号"
        width="60"
      />

      <bsp-table-column
        field="id"
        filter-type="input"
        :showPagination="false"
        :visible="false"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="empName"
        title="姓名"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.empName }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="orgId"
        title="所属机构"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.deptName }}</span>
        </template>
      </bsp-table-column>

<!--      <vxe-table-column-->
<!--        field="orgId"-->
<!--        title="所属机构"-->
<!--        :filters="[{data: null}]"-->
<!--        :filter-render="{name: 'ElSelect', options: deptList, props: {placeholder: '请选择'}}"-->
<!--      >-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ scope.row.deptName }}</span>-->
<!--        </template>-->
<!--      </vxe-table-column>-->

      <bsp-table-column
        field="idCard"
        title="证件号码"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.idCard }}</span>
        </template>
      </bsp-table-column>

    </bsp-table>
  </div>
</template>

<script>
  import defaultInvoice from "@/components/bsp/bsp-dicts-invoice/default";
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import { queryPersonListPage,saveWageAttachEmp } from  "@/api/wage/attachmentManage"
  import { getEmpDeptList } from  "@/api/org/org";
  import { mapGetters } from 'vuex';
  export default {
    name: "Table",
    components: { bspTableColumn, bspTable},
    props:{
      perDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      outPerDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      state: {
        type: String,
        default: '',
      },
      dialogheaderVisible: {
        type: Boolean,
        default: false,
      },
      cusId: {
        type: String,
        default: '',
      },
    },
    created(){
        // this.deptList = [ { "value": "4028abee7227204501722c13466e0090", "label": "测试_子公司" },
        //     { "value": "4028b88172745307017274961714004d", "label": "测试0602" },
        //     { "value": "28041196A2674A6BB63665B15CB40FBD", "label": "薪智云测试客户1" },
        //     { "value": "4028abee72173fb20172269c3a240151", "label": "测试0525" },
        //     { "value": "4028abee7227204501722c12d939008a", "label": "测试_子公司2" } ]
      this._getDeptName();
      this._getListpage();
    },
    mounted() {

    },
    computed: {
      ...mapGetters([
        'dicts',
        'pms'
      ]),
    },
    data(){
      return{
        orgIds:[],
        list: [],
        perList:[],
        multipleSelection: [],
        loading:false,
        listQuery:{
          limit: 20,
          page: 1,
          total: 0,
          orgMap:{},
          orgList:[],
          deptList:[],
          perDatas:[],
          outPerDatas:[],
          state:"",
          batchId : this.$route.query.batchId,
          sameBatchId: "YES"
        },
        parameter:{
            orgId:null,
            orgIds:null,
            cusId:''
        }
      }
    },
    methods: {

      //复选框全选事件
      selectAll({checked, selection}){
        this.multipleSelection = selection;
        console.log("全选-----",JSON.stringify(this.multipleSelection))
      },
      _getDeptName(){
          this.parameter.cusId = this.cusId;
          console.log("this.parameter====666999999=====",this.parameter);
          getEmpDeptList(this.parameter).then(res=>{
            console.log("getEmpDeptList-====res==",res);
            if(res.data.data){
                this.deptList = [];
                res.data.data.forEach(row=>{
                    console.log("row==---669999",row)
                    let obj = {};
                    obj.value = row.id;
                    obj.label = row.deptname;
                    this.deptList.push(obj);
                })
            }
            console.log("this.deptList====",this.deptList)
          })
      },

      //获取列表数据
      _getListpage(e){
        console.log("orgMaps-----",e)
        console.log("perDatas-----",this.perDatas)
        console.log("outPerDatas-----",this.outPerDatas)
        if(e!=undefined){
          this.listQuery.orgList = e;
        }
        this.listQuery.perDatas = this.perDatas;
        this.listQuery.outPerDatas = this.outPerDatas;
        this.listQuery.state = this.state;
        this.listQuery.batchId = this.$route.query.batchId;
        queryPersonListPage(this.listQuery).then(res => {
          this.listQuery.total = res.data.total;
          this.list = res.data.records;
          console.log("获取人员数据list---"+this.list);
          console.log("2222人员列表数据JSON.stringify(res.data.records)==",JSON.stringify(res.data.records));
        })
      },

      //批量更改状态
      selectChange({checked, row}){
       console.log("checked=",checked);
       console.log("row=",row);
        if(checked){
          this.multipleSelection.push(row)
        }
        if(!checked){
          this.multipleSelection.filter((item,index) => {
              console.log("!checked==item==",item);
              console.log("!checked==index=",index);
            if(item===row){
              this.multipleSelection.splice(index,1)
            }
          })
        }

      },

      _saveWageAttachEmp(){
        let listSize=this.multipleSelection.length;
        if(listSize==0){
          this.$message.error('请至少选中一行')
        }else{
          let batchId = this.$route.query.batchId;
          let obj = {
            data:this.multipleSelection,
            batchId:batchId
          }
            //调用数据新增保存接口
            this.$confirm('是否确认提交新增数据?','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                console.log("确定事件---:",obj);
                saveWageAttachEmp(obj).then(res => {
                    console.log("saveWageAttachEmp==res==",res);
                    console.log("res.data.data=",res.data.data);
                    if(res.data.data){
                        this.$emit("refushSelectPerson");
                        this.loading = false;
                    }
                })
            }).catch(()=>{
                this.loading = false;
            })


        }
      },
    },

  }
</script>

<style scoped>

</style>
